import { PlusOutlined } from '@ant-design/icons'
import { Typography } from 'antd'
import cls from 'classnames'
import React from 'react'

import { WebsiteCategoryInfoWithPaginatedFragment } from '@/generated/graphql'

import { useIsSystemAdmin } from '../admin/admin.hooks'
import { WebsiteCard } from './website-card/website-card.component'
import { WebsiteCategoryCreateEditModal } from './website-modal/website-category-create-edit-modal.component'
import { WebsiteCreateEditModal } from './website-modal/website-create-edit-modal.component'
import s from './websites.module.less'

export const WebSiteList: React.FC<{
  websiteCategory: WebsiteCategoryInfoWithPaginatedFragment
}> = ({ websiteCategory }) => {
  const isSystemAdmin = useIsSystemAdmin()

  const websites = websiteCategory.websites.edges.slice().map(({ node }) => node)

  const title = (
    <Typography.Title className={cls({ [s.edit]: isSystemAdmin })} level={5}>
      {websiteCategory.title}
    </Typography.Title>
  )

  const header = (
    <div className={s.header}>
      <div className={s.title}>
        {isSystemAdmin ? (
          <WebsiteCategoryCreateEditModal websiteCategory={websiteCategory}>{title}</WebsiteCategoryCreateEditModal>
        ) : (
          title
        )}
        <div className={s.categoryActions}>
          {isSystemAdmin && (
            <div className={s.add}>
              <WebsiteCreateEditModal websiteCategoryId={websiteCategory.websiteCategoryId}>
                <PlusOutlined />
              </WebsiteCreateEditModal>
            </div>
          )}
        </div>
      </div>
    </div>
  )

  return (
    <div className={s.list}>
      {header}
      <div>
        {websites.map((website) => (
          <WebsiteCard key={website.websiteId} website={website} />
        ))}
      </div>
    </div>
  )
}
